<template>
    <div class="mt-0 flex flex-col min-h-screen bg-gray-200">
        <div class="flex flex-col flex-1">
            <Navigation :email="subscriptions[0].email" />
            <div class="md:p-8 p-3 mb-20 flex flex-col">
                <div class="bg-white p-10 mx-auto w-full max-w-3xl shadow">
                    <div class="mx-auto text-center flex flex-col">
                        <span class="text-lg">Bienvenue {{ subscriptions[0].name }},</span>
                        <span class="text-2xl">Vos adhésions MiCare :</span>
                    </div>
                    
                    <div class="my-10 flex flex-col divide-y">
                        <subscription-item v-for="subscription in subscriptions" :key="subscription.id" :subscription="subscription" />

                        <!--
                        <subscription-item :subscription="{product_model: 'Mi Electric Scooter', product_serial: '1291284214829', can_claim: false, 'verbose_subscribed_at': '03/11/2019',id: '5f6a6609d7552821210c7364', 'src': 'https://i01.appmifile.com/webfile/globalimg/kr/scooter.jpg?width=300&height=300'}" />
                        <subscription-item :subscription="{type: 'phone_breakage', product_model: 'Mi Note 9', imei: '1291284214829', can_claim: true, 'verbose_subscribed_at': '01/09/2020',id: '5f6a6609d7552821210c7364', 'src': 'https://i01.appmifile.com/webfile/globalimg/Cambridge/800-800/J9-blue.png?width=300&height=300'}" />
                        <subscription-item :subscription="{type: 'trottinette', product_model: 'Mi Electric Scooter', product_serial: '1291284214829', can_claim: true, 'verbose_subscribed_at': '05/09/2020',id: '5f6a6609d7552821210c7364', 'src': 'https://i01.appmifile.com/webfile/globalimg/kr/scooter.jpg?width=300&height=300'}" />
                        <subscription-item :subscription="{type: 'nomades', product_model: 'Produits nomades', can_claim: true, 'verbose_subscribed_at': '13/09/2020',id: '5f6a6609d7552821210c7364'}" />
                        -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Navigation from '@/components/client/Navigation'
import SubscriptionItem from '@/components/client/SubscriptionItem'

import { getSubscriptions } from '@/auth'

export default {
    components: { Navigation, SubscriptionItem },
    data: function () {
        return {
            subscriptions: null
        }
    },
    mounted: function () {
        getSubscriptions()
        .then(({data}) => {
            this.subscriptions = data.subscriptions
        }).catch(() => {
            window.sessionStorage.removeItem('access_token')
            this.$router.push('/?session=expired')
        })
    },
}
</script>